import classNames from 'clsx'

import { SIDE_LEFT, SIDE_RIGHT } from '../../../constants'

import styles from './index.module.scss'

export function buildClassNames(props = {}) {
  const {
    className,
    narrow,
    margin,
    marginBottom,
    marginTop,
    offset,
    offsetSide,
  } = props

  return classNames(
    className,
    styles['m-article-content'],
    {
      [styles['m-article-content--narrow']]: narrow,
      [styles['m-article-content--margin']]: margin,
      [styles['m-article-content--margin-bottom']]: marginBottom,
      [styles['m-article-content--margin-top']]: marginTop,
    },
    buildOffsetClassNames({
      offset,
      side: offsetSide,
    }),
  )
}

export function buildOffsetClassNames({ className, offset, side }) {
  return classNames(
    className,
    {
      [styles['m-article-content__offset']]: offset,
      [styles['m-article-content__offset-left']]: side === SIDE_LEFT,
      [styles['m-article-content__offset-right']]: side === SIDE_RIGHT,
    },
  )
}

export function buildBreakClassNames({ className, side }) {
  return classNames(
    className,
    {
      [styles['m-article-content__break-left']]: side === SIDE_LEFT,
      [styles['m-article-content__break-right']]: side === SIDE_RIGHT,
    },
  )
}
